// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var IdMaker$SmartcutsMacros = require("../../bs-utils/src/IdMaker.bs.js");

var SmartcutId = IdMaker$SmartcutsMacros.Make({
      name: "smartcutId"
    });

var RecordedSmartcutId = IdMaker$SmartcutsMacros.Make({
      name: "recordedSmartcutId"
    });

var include = IdMaker$SmartcutsMacros.Make({
      name: "installedSmartcutId"
    });

var id_encode = include.id_encode;

var id_decode = include.id_decode;

var InstalledSmartcutId_doesEqualStringId = include.doesEqualStringId;

var InstalledSmartcutId_cmp = include.cmp;

var InstalledSmartcutId = {
  id_encode: id_encode,
  id_decode: id_decode,
  doesEqualStringId: InstalledSmartcutId_doesEqualStringId,
  cmp: InstalledSmartcutId_cmp,
  emptyId: "Empty id"
};

function smartcutId_encode(v) {
  return Curry._1(SmartcutId.id_encode, v);
}

function smartcutId_decode(v) {
  return Curry._1(SmartcutId.id_decode, v);
}

var installedSmartcutId_encode = Curry.__1(id_encode);

var installedSmartcutId_decode = Curry.__1(id_decode);

function recordedSmartcutId_encode(v) {
  return Curry._1(RecordedSmartcutId.id_encode, v);
}

function recordedSmartcutId_decode(v) {
  return Curry._1(RecordedSmartcutId.id_decode, v);
}

exports.SmartcutId = SmartcutId;
exports.RecordedSmartcutId = RecordedSmartcutId;
exports.InstalledSmartcutId = InstalledSmartcutId;
exports.smartcutId_encode = smartcutId_encode;
exports.smartcutId_decode = smartcutId_decode;
exports.installedSmartcutId_encode = installedSmartcutId_encode;
exports.installedSmartcutId_decode = installedSmartcutId_decode;
exports.recordedSmartcutId_encode = recordedSmartcutId_encode;
exports.recordedSmartcutId_decode = recordedSmartcutId_decode;
/* SmartcutId Not a pure module */
